module.exports = __webpack_public_path__ + "img/ser4.1cf6f940.png";